import { CustomersApi } from "../api/customers_api"
import { PaginationResult, NullableNumber } from "../core/common_types";
import { Customer } from "../models/customer";
import { User } from "../models/user";

export const useCustomersService = () => {
    return {
        async search(currentUser: User, searchText: string, page: number, pageSize: number): Promise<PaginationResult<Customer>> {
            let result = await CustomersApi.search(currentUser, searchText, page, pageSize);

            if (!result.success) {
                throw result.message;
            }

            return result.data;
        },
        async findServiceCustomerId(currentUser: User, parentId: number): Promise<NullableNumber> {
            let result = await CustomersApi.findServiceCustomerId(currentUser, parentId);

            if (!result.success) {
                throw result.message;
            }

            return result.data;
        }
    }
}